<template>
    <div class="framework">
        <div class="side-panel" :class="{'minimized': sidePanel.minimized || sidePanel.submenu, 'details': sidePanel.details}">
            <slot name="side"></slot>
        </div>
        <div class="sub-menu" v-if="sidePanel.submenu">
            <slot name="submenu"></slot>
        </div>
        <div class="main-panel" :style="{'background': colors.background1 + ' radial-gradient(' + colors.background1 + ',' + colors.background2 + ')'}">
            <slot name="main"></slot>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Framework",
        computed: {
            ...mapGetters(['currentUser', 'sidePanel', 'colors']),
        }
    };
</script>

<style lang="scss" scoped>
    .framework {
        display: flex;
        flex-direction: row;
        height: 100%;
        overflow: hidden;

        .side-panel {
            position: relative;
            width: 280px;
            min-width: 280px;
            transition: width 100ms;
            box-shadow: 5px 0 30px 0 rgba(0, 0, 0, 0.3);
            z-index: 100;

            @media (max-width: 768px) {
                position: fixed;
                top: 0;
                bottom: 0;
                left: 0;
                transition: none;
            }

            &.minimized {
                width: 63px !important;
                min-width: 63px !important;
                box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.3);

                @media (max-width: 768px) {
                    width: 49px !important;
                    min-width: 49px !important;
                }
            }

            &.details {
                width: 360px;
                min-width: 360px;
            }
        }

        .sub-menu {
            position: relative;
            z-index: 99;
            border-left: 1px solid #ececec;
            overflow-y: auto;

            box-shadow: 5px 0 30px 0 rgba(0, 0, 0, 0.3);
        }

        .main-panel {
            background: #224C74 radial-gradient(#336699, #213f6a);
            overflow-y: auto;
            position: relative;
            flex-grow: 1;

            padding: 1.5rem 4.5rem 0 5rem;

            @media (max-width: 1180px) {
                padding: 0 3rem 1.5rem 45px;
            }

            @media (max-width: 850px) {
                padding: 0 2rem 1.5rem 45px;
            }

            @media (max-width: 768px) {
                padding: 0 1.5rem 1.5rem 76px;
            }
        }
    }
</style>
